<div class="login-container">
  <div class="login-header">
    <h1>DevHubCentral</h1>
    <div class="login-image">
      <img src="icon/undraw_cloud-hosting_tfeh.png" alt="" width="65%" />
    </div>
  </div>

  <div class="login-actions">
    @if (errorMessage) {
      <p role="alert">{{ errorMessage }}</p>
    }
    @if (linkRequired) {
      <button class="btn primary" (click)="continueWithLocalAccount()">
        Entrar e vincular conta
      </button>
    }
    <p>Entre com sua conta para acessar todos os nossos serviços.</p>

    <button class="btn primary" (click)="goTo('login')">Entrar</button>
    <button class="btn secondary" (click)="goTo('register')">
      Criar Conta
    </button>
    <div class="divider">
      <span>OU</span>
    </div>
    <button class="btn google" (click)="loginWithGoogle()">
      Login com Google
    </button>
  </div>
</div>
